import { Grid, Typography } from "@mui/material";
import { MprcContainer } from "components";
import { ActivityComponentDto, EnrollStatus } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";
import { EnrollmentCloseButton } from "views/lms/student/EnrollmentView/Shared/EnrollmentCloseButton";
import { EnrollmentStatus } from "views/lms/student/EnrollmentView/Shared/EnrollmentStatus";
import { ScoreResult } from "views/lms/student/EnrollmentView/Shared/ScoreResult";
import { TrainingAvatar } from "views/lms/student/EnrollmentView/Shared/TrainingAvatar";
import { TrainingDueDate } from "views/lms/student/EnrollmentView/Shared/TrainingDueDate";
import { TrainingInteractions } from "views/lms/student/EnrollmentView/Shared/TrainingInteractions";
import { useEnrollmentViewContext } from "../../..";

/////////////////////////////////////////////////////////////////////////////////////
interface IProps {
    activity: ActivityComponentDto;
}

/////////////////////////////////////////////////////////////////////////////////////

export const ActivityHeaderContent = (props: IProps) => {

    const { activity } = props;
    const { t } = useTranslation("lms");

    const { enrollment } = useEnrollmentViewContext();

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
                <Grid container spacing={2} wrap="nowrap">
                    <Grid>
                        <TrainingAvatar />
                    </Grid>
                    <Grid size="grow">
                        <MprcContainer>
                            {(enrollment.status == EnrollStatus.NotStarted || enrollment.status == EnrollStatus.InProgress)
                                ? <TrainingDueDate enrollment={enrollment} />
                                : <EnrollmentStatus variant="block" data={enrollment!} />
                            }
                        </MprcContainer>
                        <MprcContainer>
                            {!enrollment.isPreview &&
                                <ScoreResult
                                    variant="single"
                                    enrollmentId={enrollment.enrollmentId}
                                    score={enrollment.scorePercent ?? activity.scorePercent}
                                    minScore={enrollment.minFinalScore}
                                    isClosed={enrollment.finalizationDate != null}
                                    status={enrollment.status}
                                    totalItems={enrollment.totalScoredComponents}
                                >
                                    <Typography variant="caption" component="p" color={"muted"}>
                                        {
                                            !activity.digitalDelivery || activity.deliveryDate == null
                                                ? <span>{t("Student.EnrollmentView.Content.Activity.DeliverText")}</span>
                                                : activity.scorePending
                                                    ? <span>{t("Student.EnrollmentView.Content.Activity.WaitingCorrectionText")}</span>
                                                    : null
                                        }
                                    </Typography>
                                </ScoreResult>
                            }
                        </MprcContainer>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Grid container spacing={2}>
                    {
                        enrollment.finalizationDate === null && enrollment.canFinish &&
                        <Grid sx={{ width: 240 }}>
                            <EnrollmentCloseButton />
                        </Grid>
                    }
                    <Grid size="grow">
                        <TrainingInteractions enrollment={enrollment} readOnly={enrollment.isPreview} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
